// Module-level singleton that holds the current org_id.
// Set once by AuthContext after org membership loads; read by all service files.
// This avoids prop-drilling org_id through every service method signature.

let currentOrgId: string | null = null;

export const orgStore = {
  setOrgId: (id: string | null) => {
    currentOrgId = id;
  },
  getOrgId: (): string | null => currentOrgId,
};
